module.exports = __webpack_public_path__ + "img/45.b9394756.jpg";